document.addEventListener("DOMContentLoaded", function () {
  var dragInfo;
  onStartItemDrag(function (startDragInfo) {
    dragInfo = startDragInfo;
    onMouseMove(function (_ref) {
      var x = _ref.x,
          y = _ref.y;
      dragInfo.mouseCoords = {
        x: x,
        y: y
      };
      var xDiff = x - dragInfo.mouseStartX;
      dragInfo.sliderElem.scrollLeft = dragInfo.sliderStartX - xDiff;
      onMouseOutOfBounds(releaseDrag);
    });
    onReleaseDrag(releaseDrag);
  }); //disableLinkClickIfDrag()
  //implementation

  var mouseMoveEffect;

  function onStartItemDrag(effect) {
    document.addEventListener('mousedown', function (_ref2) {
      var target = _ref2.target,
          x = _ref2.x,
          y = _ref2.y;
      var sliderElem = document.querySelector('[data-upsell-items]');
      var item = target.closest('[data-upsell-item]');

      if (item && sliderElem) {
        var sliderStartX = sliderElem.scrollLeft;
        var _dragInfo = {
          item: item,
          mouseStartX: x,
          sliderStartX: sliderStartX,
          sliderElem: sliderElem,
          mouseCoords: {
            x: x,
            y: y
          }
        };
        setTimeout(function () {
          return effect(_dragInfo);
        }, 100); //delay for click
      }
    });
  }

  function onMouseOutOfBounds(effect) {
    var _dragInfo2 = dragInfo,
        sliderElem = _dragInfo2.sliderElem,
        mouseCoords = _dragInfo2.mouseCoords;

    var _sliderElem$getBoundi = sliderElem.getBoundingClientRect(),
        x = _sliderElem$getBoundi.x,
        y = _sliderElem$getBoundi.y,
        height = _sliderElem$getBoundi.height,
        width = _sliderElem$getBoundi.width;

    if (mouseCoords.x < x || mouseCoords.x > x + width || mouseCoords.y < y || mouseCoords.y > y + height) {
      effect();
      document.removeEventListener('mousemove', mouseMoveEffect);
    }
  }

  function onReleaseDrag(effect) {
    document.addEventListener('mouseup', onMouseUp);

    function onMouseUp() {
      effect();
      document.removeEventListener('mouseup', onMouseUp);
      return false;
    }
  }

  function releaseDrag() {
    resetDragInfo();
    document.removeEventListener('mousemove', mouseMoveEffect);
    snapToNearestItem();

    function resetDragInfo() {
      setTimeout(function () {
        return dragInfo = {
          sliderElem: dragInfo.sliderElem
        };
      }, 100); // delay for click
    }
  }

  function snapToNearestItem() {}

  function onMouseMove(effect) {
    mouseMoveEffect = function mouseMoveEffect(_ref3) {
      var x = _ref3.x,
          y = _ref3.y;
      return effect({
        x: x,
        y: y
      });
    };

    document.addEventListener('mousemove', mouseMoveEffect);
  }

  function preventIfDragging(e) {
    var _dragInfo3;

    if (((_dragInfo3 = dragInfo) === null || _dragInfo3 === void 0 ? void 0 : _dragInfo3.sliderStartX) != undefined) {
      e.preventDefault();
    }
  }

  window.preventIfDragging = preventIfDragging;
});